"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function deserializeBoolean(value) {
    if (typeof value !== 'boolean')
        throw new Error('Value is not a boolean');
    return value;
}
exports.default = deserializeBoolean;
